import React from 'react';

import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

import FormControl from '@material-ui/core/FormControl';

import { EvaluatorDropdownContext } from './table';

import { Modal } from '@material-ui/core';

function EvaluatorDropdown({ params }) {
  const mTableProps = React.useContext(EvaluatorDropdownContext);

  const [selectedUser, setSelectedUser] = React.useState({
    id: null,
    name: null,
  });
  const [openModal, setOpenModal] = React.useState(false);
  const [tableProps, setTableProps] = React.useState(null);

  const goalType = params.data.goalType;
  const adminStatus = params.data.adminStatus;

  React.useEffect(() => {
    mTableProps.evaluatorList.sort((a, b) => {
      const mCourseType =
        goalType === 'dataScience' ? 'data-science' : goalType;

      if (a.courseType === mCourseType && b.courseType !== mCourseType)
        return -1;
      if (a.courseType !== '' && b.courseType === '') return -1;

      return 0;
    });
    setTableProps(mTableProps);
  }, [mTableProps]);

  if (!tableProps) return <></>;

  const getValue = () => {
    if (!params.data.evaluatorUserId || !tableProps.evaluatorList) return null;
    const index = tableProps.evaluatorList.findIndex(
      (item) => item.userId === params.data.evaluatorUserId
    );
    return index < 0 ? null : tableProps.evaluatorList[index];
  };

  const isSelectDisabled = (() => {
    if (adminStatus !== 'accepted') return true;

    return false;
  })();

  return (
    <div className='w-full '>
      <FormControl variant='outlined' className='w-full '>
        <Autocomplete
          disabled={isSelectDisabled}
          options={tableProps?.evaluatorList || []}
          getOptionLabel={(option) => {
            return option?.User?.firstName + ' ' + option.User?.lastName;
          }}
          renderOption={(option) => (
            <div className='flex gap-2 w-full items-center'>
              <div className='flex-1 '>
                {option?.User?.firstName} {option.User?.lastName}
              </div>
              <div className='text-gray-400 text-sm'>
                {option.courseType === 'data-science' && 'DS'}
                {option.courseType === 'web3' && 'WD'}
                {option.courseType === 'ug-diploma-cs' && 'UG'}
              </div>
            </div>
          )}
          value={getValue()}
          onChange={(event, newValue) => {
            if (!newValue) return;

            setSelectedUser({
              id: newValue.userId,
              name: newValue?.User?.firstName + ' ' + newValue.User?.lastName,
            });
            setOpenModal(true);
          }}
          renderInput={(params) => <TextField {...params} variant='outlined' />}
        />
      </FormControl>

      <Modal open={openModal}>
        <div className='relative top-2 md:top-10 m-auto bg-ab-tertiary bg-white rounded-lg md:px-8 px-3 py-4 z-50 lg:w-1/2 w-11/12 border-solid border border-gray-600 p-50'>
          <div
            className='absolute right-2 top-2 cursor-pointer'
            onClick={() => {
              setOpenModal(false);
            }}
          >
            X
          </div>

          <h2 className='font-bold text-center'>
            Are you sure, you want to assign this to {selectedUser?.name}?
          </h2>

          <hr />

          <div className='flex justify-end'>
            <button
              className='bg-red-c3 p-1 px-2 rounded-md text-white'
              onClick={() => {
                tableProps.evaluatorChangeFn(
                  params.data.submissionId,
                  selectedUser.id
                );

                setOpenModal(false);
              }}
            >
              OK
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default EvaluatorDropdown;
